/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionAnchor
 */
export interface InputUavMissionAnchor {
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionAnchor
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionAnchor
     */
    lng: number;
}

/**
 * Check if a given object implements the InputUavMissionAnchor interface.
 */
export function instanceOfInputUavMissionAnchor(value: object): boolean {
    if (!('lat' in value)) return false;
    if (!('lng' in value)) return false;
    return true;
}

export function InputUavMissionAnchorFromJSON(json: any): InputUavMissionAnchor {
    return InputUavMissionAnchorFromJSONTyped(json, false);
}

export function InputUavMissionAnchorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionAnchor {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function InputUavMissionAnchorToJSON(value?: InputUavMissionAnchor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

